import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, throttleTime } from 'rxjs';

export const V4_INPUT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4InputComponent),
  multi: true,
};

@Component({
  selector: 'v4-widget-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [V4_INPUT_VALUE_ACCESSOR],
})
export class V4InputComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder = 'Input';
  @Input() size: 'default' | 'large' = 'default';
  @Input() showSearchIcon = false;
  @Input() debounceTime = 300;
  _registerOnChange: (value: any) => void = (_: any) => {};
  form: UntypedFormGroup = this.fb.group({
    value: null,
  });

  get value() {
    return this.form.value.value;
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.subscribeValueChange();
  }

  private subscribeValueChange() {
    this.form
      .get('value')
      .valueChanges.pipe(debounceTime(this.debounceTime))
      .subscribe((rst) => {
        console.log('rst: ', rst);
        this._registerOnChange(rst);
      });
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    this.form.patchValue({ value }, { emitEvent: false });
  }

  // onValueChange(value) {
  //   this._registerOnChange(value);
  // }
}
